// oxlint-disable-next-line no-restricted-imports
import { Box, Group } from "@mantine/core";

import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";

import classes from "./Loader.module.css";

type LoaderSize = "small" | "large";

const SIZE_MAP: Record<LoaderSize, { dot: string; gap: string }> = {
  small: { dot: spacing[1.5], gap: spacing[1] },
  large: { dot: spacing[3], gap: spacing[2] },
};

const DOT_KEYS = ["first", "second", "third"] as const;

type LoaderProps = {
  size?: LoaderSize;
  style?: React.CSSProperties;
};

const Loader = ({ size = "small", style }: LoaderProps) => {
  const { dot, gap } = SIZE_MAP[size];

  return (
    <Group
      gap={gap}
      align="center"
      style={
        {
          ...style,
          "--loader-color-1": colors.border.tertiary,
          "--loader-color-2": colors.icon.secondaryInverse,
          "--loader-color-3": colors.text.neutral,
        } as React.CSSProperties
      }
    >
      {DOT_KEYS.map((key) => (
        <Box key={key} w={dot} h={dot} className={classes.dot} style={{ borderRadius: "50%" }} />
      ))}
    </Group>
  );
};

export { Loader };
export type { LoaderSize };
